import axios from "axios";
import { getAuth } from "firebase/auth";

import app from "../../config/firebase";

const API_URL = process.env.REACT_APP_API_URL;

const getAchievements = async () => {
  const auth = getAuth(app);
  const token = await auth.currentUser.getIdToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL + "profile/achievements", config);

  return response.data;
};

const achievementService = {
  getAchievements,
};

export default achievementService;
